"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getItemLink = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var util_1 = require("../common/util");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var getItemLink = function getItemLink(item, productUrl, storeDirectory, setSearchText) {
  var partNumber = (item === null || item === void 0 ? void 0 : item.altPartNumber) && (item === null || item === void 0 ? void 0 : item.altPartNumber.slice(0, 3)) === "CPN" ? item === null || item === void 0 ? void 0 : item.altPartNumber : item === null || item === void 0 ? void 0 : item.partNumber;
  return (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
    onClick: function onClick() {
      return setSearchText && setSearchText("");
    },
    children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
      className: "search-item-".concat(storeDirectory),
      to: (0, frontend_common_1.navigateToProductDetails)(productUrl, partNumber, storeDirectory),
      gatsby: (0, util_1.isGatsbyLink)(true, storeDirectory || ""),
      size: "md",
      autoResize: true,
      children: partNumber
    })
  });
};

exports.getItemLink = getItemLink;